import React, { Component } from 'react';

export default class InputRows extends Component {
	shouldComponentUpdate = nextProps => {
		const result =
			this.props.onInputChange !== nextProps.onInputChange ||
			this.props.isMandatory !== nextProps.isMandatory ||
			this.props.value !== nextProps.value ||
			this.props.error !== nextProps.error ||
			this.props.disabled !== nextProps.disabled ||
			this.props.type !== nextProps.type ||
			this.props.min !== nextProps.min ||
			this.props.max !== nextProps.max ||
			this.props.className !== nextProps.className ||
			this.props.title !== nextProps.title ||
			this.props.placeholder !== nextProps.placeholder ||
			this.props.onKeyPress !== nextProps.onKeyPress ||
			this.props.pinInputToBottom !== nextProps.pinInputToBottom ||
			this.props.step !== nextProps.step ||
			this.props.inputMode !== nextProps.inputMode;
		// console.log(this.props.title + ': ' + result);

		return result;
	};

	handleInputChange = event => {
		this.props.onInputChange(this.props.keyProps, event.target.value);
	};

	render() {
		var mandatory;
		var inputAlert;
		if (this.props.isMandatory) {
			mandatory = <span style={{ color: 'red' }}> *</span>;
		}

		if ((!this.props.value && this.props.isMandatory) || this.props.error) {
			inputAlert = 'is-danger';
		}

		var disabled;
		if (this.props.disabled) {
			disabled = 'disabled';
		}

		var type = 'text';
		if (this.props.type) {
			type = this.props.type;
		}

		const isNumberType = type === 'number';

		var minLength;
		var maxLength;
		var min;
		var max;
		if (isNumberType) {
			if (this.props.min !== undefined && this.props.min !== null && this.props.min !== '') {
				min = this.props.min;
			}
			if (this.props.max !== undefined && this.props.max !== null && this.props.max !== '') {
				max = this.props.max;
			}
		} else {
			if (this.props.min !== undefined && this.props.min !== null && this.props.min !== '') {
				minLength = this.props.min;
			}
			if (this.props.max !== undefined && this.props.max !== null && this.props.max !== '') {
				maxLength = this.props.max;
			}
		}

		// Decimal example: step={0.01} → 2 decimal places (e.g. money); step={0.001} → 3; omit or step="any" for no step constraint.
		let step;
		if (isNumberType) {
			if (this.props.step !== undefined && this.props.step !== null && this.props.step !== '') {
				step = this.props.step;
			} else {
				step = 'any';
			}
		}

		let inputMode;
		if (this.props.inputMode != null) {
			inputMode = this.props.inputMode;
		} else if (isNumberType) {
			inputMode = 'decimal';
		}

		const moreClasses = this.props.className ? this.props.className : '';
		const hideLabel = this.props.hideLabel ? this.props.hideLabel : false;
		const pinInputToBottom = !!this.props.pinInputToBottom;
		const rootStyle = pinInputToBottom ? { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, width: '100%' } : undefined;
		const controlStyle = pinInputToBottom ? { marginTop: 'auto', width: '100%' } : undefined;
		return (
			<div style={rootStyle}>
				{!hideLabel ? (
					<label className="label" style={{ color: 'black' }}>
						{this.props.title}
						{mandatory}
					</label>
				) : null}
				<div className="control" style={controlStyle}>
					<input
						className={'input ' + inputAlert + ' ' + moreClasses}
						type={type}
						placeholder={this.props.placeholder}
						value={this.props.value == null ? '' : this.props.value}
						onChange={this.handleInputChange}
						disabled={disabled}
						min={isNumberType ? min : undefined}
						max={isNumberType ? max : undefined}
						step={step}
						inputMode={inputMode}
						minLength={minLength}
						maxLength={maxLength}
						onKeyPress={this.props.onKeyPress ? this.props.onKeyPress : () => {}}
					/>
				</div>
			</div>
		);
	}
}
